export enum ETransactionType {
    INCOME = 1,
    EXPENSE = 2,
    TRANSFER_INCOME = 3,
    TRANSFER_EXPENSE = 4,
}
